import React from "react";
import "./component.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../Loading/component";
import Box from "@mui/material/Box";

import {
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Typography,
} from "@mui/material";

export const ComboCohortAddComponent = (props) => {
  const { comboId } = useParams();

  const navigate = useNavigate();

  const arrowClick = (event) => {
    event.preventDefault();
    navigate(-1);
  };
  return (
    <div className="main-div" style={{ margin: "auto" }}>
      <div>
        <Sidebar />
      </div>

      {props.loading ? (
        <>
          <LoadingSpinner />
        </>
      ) : (
        <>
          <div
            style={{
              margin: "auto",
              overflow: "auto",
              height: "100vh",
              width: "90vw",
            }}
          >
            <div>
              <div>
                <h2 style={{ width: "360px", margin: "8px" }}>
                  <img
                    onClick={arrowClick}
                    style={{ width: "22px", cursor: "pointer" }}
                    src={leftArrow}
                    alt=""
                  />{" "}
                  combo map
                </h2>
              </div>
              <div
                style={{
                  width: "83vw",
                  height: "93vh",
                  backgroundColor: "#fff",
                  margin: "auto",
                  padding: "20px",
                  borderRadius: "14px"
                }}
              >
                <Box
                  sx={{ width: "440px", margin: "auto", alignItems: "center" }}
                >
                  <form style={{ marginTop: "140px" }}>
                    <Typography
                      variant="h6"
                      component="label"
                      gutterBottom
                      style={{ fontWeight: "bold" }}
                    >
                      Cohort ID<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      type="number"
                      variant="standard"
                      placeholder="Enter ID"
                      value={props.cohortId}
                      onChange={(e) => props.setCohortId(e.target.value)}
                      error={!!props.error.cohortId}
                      helperText={props.error.cohortId}
                      style={{ marginBottom: "20px" }}
                      sx={{
                        "& .MuiInput-underline:before": {
                          borderBottomColor: "#14AE78",
                        },
                        "& .MuiInput-underline:after": {
                          borderBottomColor: "#14AE78",
                        },
                      }}
                    />

                    <Typography
                      variant="h6"
                      component="label"
                      gutterBottom
                      style={{ fontWeight: "bold" }}
                    >
                      VM ID<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <p style={{ color: "#00000073", fontSize: "18px", fontWeight: 300 }}>Select VM ID</p>
                    <RadioGroup
                      value={props.vmIdOption}

                      onChange={(e) => props.setVmIdOption(e.target.value)}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "20px",
                      }}
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio style={{ color: "#14AE78" }} />}
                        label="All"
                      />
                      <FormControlLabel
                        value="selectedOnly"
                        control={<Radio style={{ color: "#14AE78" }} />}
                        label="Selected Only"
                      />
                    </RadioGroup>

                    {props.vmIdOption === "selectedOnly" && (
                      <TextField
                        fullWidth
                        error={!!props.error.vmId}
                        helperText={props.error.vmId}
                        variant="standard"
                        placeholder="Enter vending machine list"
                        value={props.vmId}
                        onChange={(e) => props.setVmId(e.target.value)}
                        style={{ marginBottom: "20px" }}
                        sx={{
                          "& .MuiInput-underline:before": {
                            borderBottomColor: "#14AE78",
                          },
                          "& .MuiInput-underline:after": {
                            borderBottomColor: "#14AE78",
                          },
                        }}
                      />
                    )}

                  </form>
                  <Box sx={{ margin: "120px" }}>
                    <Button
                      onClick={props.handleApply}
                      variant="contained"
                      color="success"
                      style={{
                        backgroundColor: "#00a651",
                        borderColor: "#00a651",
                        borderRadius: "8px",
                        padding: "10px 60px",
                      }}
                    >
                      Apply
                    </Button>
                  </Box>
                </Box>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
